module.exports = __webpack_public_path__ + "img/shopee.2f754ed6.png";